<template>
  <div>
    <div class="modal fade" id="update-amazon-inventory-fnsku-modal" role="dialog" data-backdrop="static" data-keyboard="false" style="top: 28%;">
      <div class="modal-dialog">
        <div class="modal-content w-500" style="margin: auto;">
          <div class="modal-body pd-b-15 pd-t-15">
            <div>商品ラベルにFNSKUを利用して頂けるようになりました。</div>
            <div>初回のみ商品の最新情報を取得させていただきます。</div>
            <div class="text-center m-t-md">
              <button type="button" class="btn btn-warning m-r-sm" data-dismiss="modal" @click="getProductAvailable()">OK</button>
            </div>
          </div>
        </div>
      </div>
    </div>

    <modal-alert-success
      v-if="showModalAlertSuccess"
      :message="`商品が最新状態に更新されました。`"
      :customBodyClass="`text-center`"
      @close="closeModalAlertSuccess"
    />
  </div>
</template>

<script>
import ProductService from '@/services/productservice'
import SettingService from '@/services/settingservice'
import ModalAlertSuccess from '@/components/ModalAlert'

export default {
  components: {
    ModalAlertSuccess
  },
  data () {
    return {
      loader: null,
      showModalAlertSuccess: false
    }
  },
  methods: {
    openModalAlertSuccess () {
      this.showModalAlertSuccess = true
    },
    closeModalAlertSuccess () {
      $('#myModal').modal('hide')
      this.showModalAlertSuccess = false
      this.getSellerInfo()
    },
    async getProductAvailable () {
      $('#update-amazon-inventory-fnsku-modal').modal('hide')
      this.loader = this.$loading.show()
      await ProductService.getProductAvailable()
        .then((response) => {
          this.loader && this.loader.hide()
          this.openModalAlertSuccess()
          this.$emit('updateAmazonInventoryFnskuSuccess')
        })
        .catch((err) => {
          this.loader && this.loader.hide()
          this.$store.commit('toggleModal', {
            show: true,
            message: err
          })
        })
    },
    async getSellerInfo (params = {}) {
      await SettingService.getSellerInformation(params)
        .then(response => {
          this.$store.commit('setUser', response.seller)
        })
        .catch(err => {
          this.error = err
        })
    }
  },
  mounted () {
    $('#update-amazon-inventory-fnsku-modal').modal('show')
  },
  beforeDestroy () {
    this.loader && this.loader.hide()
    $('#update-amazon-inventory-fnsku-modal').modal('hide')
    $('.modal-backdrop').remove()
  }
}
</script>



// WEBPACK FOOTER //
// src/view/deliveryRequests/components/UpdateAmazonInventoryFnskuModal.vue